import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from './SessionDialog'

const TextArea = styled.textarea`
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
  &:focus {
    outline: 2px solid ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    outline-offset: 1px;
  }
`

const Note = styled.p`
  margin: 0 0 12px;
  font-size: 13px;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
`

export default function RescheduleDialog({ open, session, onClose, onSubmit }) {
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)

  if (!session) return null

  async function handleSubmit() {
    setBusy(true)
    try {
      await onSubmit({ newSlotId: null, reason: reason.trim() || null })
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title="Request reschedule"
      subtitle={`We'll let ${session.practitionerName} know you'd like a different time.`}
      primaryLabel="Submit request"
      onPrimary={handleSubmit}
      primaryLoading={busy}
      onClose={onClose}
    >
      <Note>What times work better for you? Free-text is fine — your practitioner picks a slot.</Note>
      <TextArea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="e.g. Mornings before 11 work best, or evenings after 6 next week"
      />
    </SessionDialog>
  )
}
